export class MegamenuItem extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.attachShadow({ mode: "open" });

		const template = document.createElement("template");

		template.innerHTML = `
			<div data-element="megamenu-item-root" part="base">
				<slot name="trigger"></slot>
			</div>
		`
			.replaceAll(/\s\s+/g, " ")
			.trim();

		this.shadowRoot?.append(template.content.cloneNode(true));
	}
}
